// helpers
import { OrderDirection } from '../../api/interfaces/responses/shared'

export enum GroupsSorting {
  NAME = 'name',
  LATEST_POST = 'latest_post',
}

export interface GroupsSortingSettings {
  sortBy: GroupsSorting;
  orderBy: OrderDirection;
}
